import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import { useFormContext } from 'modules/client/common/forms/taxResidencyForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends Omit<FormContentProps, 'onRemoveTaxResidency'> {}

export const TaxResidencySection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();
  const { readOnly, values, setFieldValue } = useFormContext();

  const onAddTaxResidency = () => {
    const taxResidences = [...values.taxResidences, { country: null }];
    setFieldValue('taxResidences', taxResidences, false);
  };

  const onRemoveTaxResidency = (index: number) => {
    const taxResidences = [...values.taxResidences];
    taxResidences.splice(index, 1);
    setFieldValue('taxResidences', taxResidences, false);
  };

  return (
    <Section
      datax="taxResidencySection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAddTaxResidency}
          />
        )
      }
      title={t('client.client.taxResidency.title')}
    >
      <FormContent {...formProps} onRemoveTaxResidency={onRemoveTaxResidency} />
    </Section>
  );
};
